import React from 'react';
import styles from './index.module.scss'

class ButtonPrimary extends React.Component {

  render() {
    return (
      <button onClick={this.props.onClick} disabled={this.props.disabled} className={`${styles.cupra} ${this.props.styletyc ? styles.tyc : ''} ${this.props.styleirvehiculo ? styles.irvehiculo : ''}`}>{this.props.textButton}</button>
    )
  }
}

export default ButtonPrimary
